import { Component, computed, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-payment-info',
  templateUrl: './payment-info.component.html',
  styleUrl: './payment-info.component.scss'
})
export class PaymentInfoComponent {

  @Input() selected = null;
  @Input() trialDays: number = null;
  @Input() disabled = false;
  @Output() selectedChange = new EventEmitter();

  choose(method: any) {
    this.selectedChange.emit(true);
    // if (this.selected !== method) {
    //   this.selected = method;
    //   this.selectedChange.emit(this.selected);
    // }
  }

  isSelected = computed(() => this.selected ? true : false)

}
